import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=370f7004&"
import script from "./WhatsApp.vue?vue&type=script&lang=js&"
export * from "./WhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports